export function card01() {
  const cards = document.querySelectorAll(".c-card01");
  if (!cards.length) return;

  const spQuery = window.matchMedia("(max-width: 768px)");

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      if (!spQuery.matches) return;
      card.classList.toggle("is-active");
    });
  });

  spQuery.addEventListener("change", (event) => {
    if (event.matches) return;
    cards.forEach((card) => card.classList.remove("is-active"));
  });
}
